<template>
  <div class="media">
    <div class="media-body item-content">
      <h5>{{ _T_DB(item, 'name') }}</h5>
    <div
      :id="'sub_dsc' + item._id"
      class="sub_container"
    >
      <div class="mt-2"
         v-for="(cmbItm, index) in item.combo_selected_items"
         :key="index"
      >
        <div class="subdescription_container">
            <span class="product_sub_description main-orders-list-item-subtitle color-text-invert item-exclude">
              {{ cmbItm.name }} x {{ cmbItm.quantity || 1 }}
            </span>
        </div>
        <ul v-if="cmbItm.modifiers">
            <li v-for="(modifier, key) in cmbItm.modifiers" :key="'mod' + key">
              <span>
                <i class="fas fa-circle"></i>
              </span>
              {{ _T_DB(modifier, 'name') }}<span>, &nbsp;</span>
            </li>
          </ul>
      </div>
    </div>
    </div>
    <div class="text-right">
      <h5 class="font-primary">x{{item.quantity}}</h5>
      <h5>{{ currency }}</h5>
      <h5>{{ Num.price(item.collectivePrice) }}</h5>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ComboItem',
  props: { item: Object },
  components: {},
  computed: {
    ...mapGetters(['_T_DB', '_T']),
  },
}
</script>